import { createSelector } from './selectorWrapper'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { pageSelectors } from './basicState'
import { safeBool } from '@utils'

export const showCastAndCrewSelector = createSelector(
  pageSelectors.castAndCrew,
  (castAndCrew?: WpsRuntime.atv.wps.CastAndCrewWidgetModelProps) =>
    Boolean(castAndCrew && !safeBool(castAndCrew.isTabbed) && castAndCrew.castAndCrews && castAndCrew.castAndCrews.length > 0)
)

export const showCastAndCrewTabsSelector = createSelector(
  pageSelectors.castAndCrew,
  (castAndCrew?: WpsRuntime.atv.wps.CastAndCrewWidgetModelProps) =>
    Boolean(castAndCrew && safeBool(castAndCrew.isTabbed) && castAndCrew.castAndCrews && castAndCrew.castAndCrews.length)
)

